import config from 'config';

const gridColumnSettings = config.get(
  'public.brand.gridColumnSettings.default'
);

export const searchMaxItemCount = 16;

export const breakpoints = [
  {
    name: 'mobile',
    ...gridColumnSettings.mobile,
    minWidth: 0,
  },
  {
    name: 'tablet',
    ...gridColumnSettings.mobile,
    minWidth: 375,
  },
  {
    name: 'tablet+',
    ...gridColumnSettings.desktop,
    minWidth: 960,
  },
  {
    name: 'desktop',
    ...gridColumnSettings.desktop,
    minWidth: 1200,
  },
  {
    name: 'desktop+',
    ...gridColumnSettings.desktop,
    minWidth: 1400,
  },
];

export const searchProductSource = config.get(
  'public.brand.searchConfig.noResults.psource'
);
